import { Pipe, PipeTransform } from '@angular/core';
import * as _ from 'lodash';
import * as debug from 'debug';

/**
 * Generated class for the FormatBonusPipe pipe.
 *
 * See https://angular.io/api/core/Pipe for more info on Angular Pipes.
 */
@Pipe({
  name: 'recommendPercent',
})
export class RecommendPercentPipe implements PipeTransform {
  log = debug('app:RecommendPercentPipe');
  /**
   * Takes a job and returns the bonus in a human readable format for job cards
   */
  transform(r: any, ...args) {
    let recommendations = _.cloneDeep(r) || {};

    if (!recommendations.positive && !recommendations.negative) {
      return 'No';
    }

    // if (!_.size(recommendations.positive)) {
    //   recommendations.positive = 0;
    // }
    // if (!_.size(recommendations.negative)) {
    //   recommendations.negative = 0;
    // }

    let positive = recommendations.positive || 0,
      negative = recommendations.negative || 0;

    this.log('recommendations', recommendations);
    let total = _.round((positive / (positive + negative)) * 100, 0);

    if (!total) {
      return '0%';
    } else {
      return total + '%';
    }
  }
}



// WEBPACK FOOTER //
// ./src/pipes/recommend-percent/recommend-percent.ts